import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { RootState } from "../../../services/redux/store";
import Typography from "@mui/material/Typography";
import DisbursementHistoryTable from "./DisbursementHistoryTable";
import DisbursementFormTerm from "./DisbursementFormTerm";
import RequestForDisbursement from "./RequestForDisbursementTerm";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import  BottomModal  from "../../../components/ui/BottomModal";
import { disbReInfo } from "../../../data/constant";
const DisbursementContainer = () => {
  const [openDisbModal, setOpenDisbModal] = React.useState(false);
  let buttonValue = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );
  const selectedIndex = useSelector(
    (state: RootState) => state.tabs.selectedIndex
  );
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const selectCreateLoan: any = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );
  const htmlContent=()=>{
    return(
      disbReInfo?.map((item: any, index: any) => (
        <Grid item xs={12} key={index}>
          <Typography
            variant="body2"
            sx={{
              cursor: "pointer",
              color: "rgba(75, 70, 92, 1)",
              fontSize: "clamp(8px, 1vw, 12px)",
            }}
          >
            <li> {item?.label}</li>
          </Typography>
        </Grid>
      ))
    )
  }
  return (
    <div>
      {buttonValue === "disbursementHistoryBtn" ? (
        <DisbursementHistoryTable showAllData={true} />
      ) : buttonValue === "createNewRequestBtn" ? (
        <DisbursementFormTerm />
      ) : (
        <>
          {isXsOrSm &&
            selectedIndex == 1 &&
            selectCreateLoan != "createNewRequestBtn" && (
              <>
                <Typography
                  sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                  letterSpacing: "1px",
                  color: "#168794",
                  display: "inline-flex",
                  alignItems: "center",
                  }}
                >
                  Fund Request
                  {isXsOrSm && (
                    <span style={{ marginLeft: 6 }}>
                      <InfoOutlinedIcon sx={{ fontSize: 16, color: "#168794", verticalAlign: "middle" }} onClick={() => {setOpenDisbModal(true)}} />
                    </span>
                  )}
                </Typography>
              </>
            )}
          <RequestForDisbursement />
        </>
      )}
      <BottomModal 
        open={openDisbModal}
        onClose={() => {setOpenDisbModal(false)}}
        children={htmlContent()}
        title="Information related to Fund Release Request"
        showCloseButton = {true}
        closeOnBackdropClick = {false}
      />
    </div>
  );
};

export default DisbursementContainer;
